import { HStack, Skeleton } from "@chakra-ui/react";
import { useContext } from "react";
import {
  FiMessageCircle,
  FiShare2,
  FiThumbsDown,
  FiThumbsUp
} from "react-icons/fi";

import { SocialShare } from "../../social-share/social-share";

import { ContributionContext } from "../context";
import { FooterIcon } from "./footer-icon";

export function Footer() {
  const {
    isThumbsUp,
    thumbsUpCount,
    handleVoteUp,
    isIconButtonPressed,
    isVoteActive,
    isVoteDisabled,
    commentsCount,
    handleComment,
    showCommentIcon,
    isThumbsDown,
    thumbsDownCount,
    handleVoteDown,
    ariaLabelVoteIcon,
    ariaLabelCommentIcon,
    ariaLabelThumbsDownIcon,
    isShareIcon,
    socialShareTitle,
    socialShareUrl,
    shareText = "Share",
    showShareText,
    handleShare,
    ariaLabelShareIcon,
    isLoaded,
    showFooter,
    makeFooterViewOnly
  } = useContext(ContributionContext);

  if (!showFooter) return null;

  if (!isLoaded) return <Skeleton h="20px" w="full" borderRadius="md" />;

  return (
    <HStack
      w="full"
      justify="space-between"
      pointerEvents={makeFooterViewOnly ? "none" : "auto"}
    >
      <HStack>
        {isThumbsUp && (
          <FooterIcon
            iconText={thumbsUpCount}
            icon={FiThumbsUp}
            onClick={handleVoteUp}
            iconAriaLabel={ariaLabelVoteIcon}
            isIconButtonPressed={isIconButtonPressed}
            testIdFooterIcon="card-thumbsUpIcon"
            testIdCountText="card-thumbsUpCountText"
            isVoteActive={isVoteActive}
            isVoteDisabled={isVoteDisabled}
          />
        )}
        {showCommentIcon && (
          <FooterIcon
            iconText={commentsCount}
            icon={FiMessageCircle}
            onClick={handleComment}
            iconAriaLabel={ariaLabelCommentIcon}
            testIdFooterIcon="card-commentIcon"
            testIdCountText="card-commentsCountText"
          />
        )}
        {isThumbsDown && (
          <FooterIcon
            iconText={thumbsDownCount}
            icon={FiThumbsDown}
            onClick={handleVoteDown}
            iconAriaLabel={ariaLabelThumbsDownIcon}
            testIdFooterIcon="card-thumbsDownIcon"
            testIdCountText="card-thumbsDownCountText"
          />
        )}
      </HStack>
      {isShareIcon && socialShareTitle && socialShareUrl && (
        <SocialShare
          placement="left"
          title={socialShareTitle}
          shareUrl={socialShareUrl}
          trigger={
            <FooterIcon
              iconText={shareText}
              icon={FiShare2}
              onClick={handleShare}
              iconAriaLabel={ariaLabelShareIcon}
              hideIconText={!showShareText}
              testIdFooterIcon="card-shareIcon"
              testIdCountText="card-shareText"
            />
          }
        />
      )}
    </HStack>
  );
}
